import styled, { css } from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import MenuCardButton from 'components/menu-card-button';
import { primitive } from 'styles/constants/primitives';

type ModalContainerProps = {
  hasOneItem: boolean;
};
type DescriptionModalProps = {
  hasOneItem: boolean;
  hasDescription: boolean;
};

const ellipsisText = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
`;

export const ModalWrapper = styled.div`
  background: rgba(0, 0, 0, 0.7);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${Styles.zIndex.max - 200};
  overflow: auto;
`;

export const ModalContainer = styled.div<ModalContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: ${Styles.color.dialogBackground};
  width: 327px;
  padding: 1.5rem;
  height: 632px;

  ${Styles.desktop`
    height: ${({ hasOneItem }: ModalContainerProps) => (hasOneItem ? '528px' : '632px')};
    width: 520px;
  `}

  ${Styles.headerMobile`
    height: ${({ hasOneItem }: ModalContainerProps) => (hasOneItem ? '504px' : '608px')};
  `}

  ${Styles.mobile`
    height: ${({ hasOneItem }: ModalContainerProps) => (hasOneItem ? '488px' : '584px')};
  `}

  .slider-slide {
    cursor: default;
  }
`;

export const ContentHeader = styled.header`
  width: 100%;
  margin-bottom: 1.5rem;
`;

export const ImageContainer = styled.div`
  height: 200px;
  width: 100%;

  ${Styles.headerMobile`
    height: 176px;
  `}
`;

export const TitleModalWrapper = styled.div`
  font: ${brandFont.headerOne};
  font-weight: bold;
  margin-bottom: 0.75rem;
  text-align: center;
  height: 67px;

  ${Styles.mobile`
    height: 60px;
  `}
`;

export const TitleModal = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  ${ellipsisText}
`;

export const DescriptionModalWrapper = styled.div<DescriptionModalProps>`
  font: ${brandFont.copyOne};
  height: ${primitive.$spacing9};
  margin-bottom: 1.5rem;
  text-align: center;
  height: ${({ hasDescription, hasOneItem }: DescriptionModalProps) =>
    (hasDescription && hasOneItem) || !hasOneItem || hasOneItem ? '40px' : 0};

  ${Styles.desktop`
    height: ${({ hasDescription, hasOneItem }: DescriptionModalProps) =>
      (hasDescription && hasOneItem) || !hasOneItem || hasOneItem ? '48px' : 0};
  `}
`;

export const DescriptionModal = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  ${ellipsisText}
`;

export const NextButton = styled(MenuCardButton)`
  transition: 0.3s;
  background-color: ${({ theme: { token } }) =>
    token('background-button-primary-default-reversed')};
  position: relative;
  bottom: 50%;
  left: 80px;
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};

  &:hover {
    background-color: ${({ theme: { token } }) =>
      token('background-button-primary-default-reversed')};
  }
  &:active {
    background-color: ${({ theme: { token } }) =>
      token('background-button-primary-default-reversed')};
  }
  svg {
    fill: ${({ theme: { token } }) => token('icon-header-contrast')} !important;
  }
`;

export const PreviousButton = styled(NextButton)`
  transform: rotate(180deg);
  left: -80px;

  &:active {
    transform: scale(0.95) rotate(180deg);
  }
`;

export const TipMessage = styled.p`
  font: ${brandFont.copyTwo};
  color: ${({ theme: { token } }) => token('text-disabled')};
  height: ${primitive.$spacing9};
  margin: ${primitive.$spacing2} 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
